<template>
    <div class="h-full w-full flex flex-col">
        <JobsForm mode="create" :partners-list="partnersList"
            :non-registered-employers-list="nonRegisteredEmployersList" @created="$emit('created')"
            @close="$emit('close')" />
    </div>
</template>

<script>
import JobsForm from "./form.vue";
export default {
    name: "jobs-create",
    props: ["partnersList", "nonRegisteredEmployersList"],
    emits: ["created", "close"],
    components: { JobsForm, },
}
</script>